export default __webpack_public_path__ + "static/media/qrpayIcon.da79b0ff.png";